import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataProfile() {
    return client.get("tunnel/api/pos/profile/data");
}

function saveAddress(params) {
    return client.post("tunnel/api/pos/profile/updatestockistaddress", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function addProfile(params) {
    return client.post("tunnel/api/pos/profile/adddata", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function updateProfileKasir(params) {
    return client.post("tunnel/api/pos/profile/updatedata", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function updateProfileUtama(params) {
    return client.post("tunnel/api/pos/profile/updatestockist", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function updateProfilePassword(params) {
    return client.post("tunnel/api/pos/profile/changePassword", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function deleteProfile(params) {
    return client.post("tunnel/api/pos/profile/deletedata", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function uploadImageKasir(params) {
    return client.post('tunnel/upload_image_cashier', params, {
        header: {
            'Content-Type': 'multipart/form-data'
        },
    });
}

function uploadImageUtama(params) {
    return client.post('tunnel/upload_image_stockist', params, {
        header: {
            'Content-Type': 'multipart/form-data'
        },
    });
}

function requestOtpCode(params) {
    return client.post("tunnel/api/pos/profile/request_otp_code", qs.stringify(params), {
        header: {
            'Content-Type': 'multipart/form-data'
        },
    });
}

function setPin(params) {
    return client.post("tunnel/api/pos/profile/set_pin", qs.stringify(params), {
        header: {
            'Content-Type': 'multipart/form-data'
        },
    });
}

export default {
    getDataProfile,
    saveAddress,
    updateProfileKasir,
    addProfile,
    deleteProfile,
    uploadImageKasir,
    uploadImageUtama,
    updateProfileUtama,
    updateProfilePassword,
    requestOtpCode,
    setPin
};